/**
 * The word a customer searches the mailbox for when the sign-up code email is
 * not in the inbox. The backend puts it into the subject and the body of that
 * email, and of no other (`searchKeyword` in custom-message-trigger) - change
 * both together.
 */
export const CODE_EMAIL_SEARCH_KEYWORD = 'Calingocode';

/**
 * The mail services whose folders and tabs the help names. Everybody else gets
 * the general tips - a Google Workspace or Microsoft 365 address on an own
 * domain included, since the domain does not tell us who hosts it.
 */
export type MailProvider = 'gmail' | 'outlook' | 'other';

const GMAIL_DOMAINS = ['gmail.com', 'googlemail.com'];
const OUTLOOK_DOMAIN = /^(outlook|hotmail|live|msn)\.[a-z.]+$/;

export function mailProviderOf(email: string | null | undefined): MailProvider {
  const domain = (email ?? '').trim().toLowerCase().split('@')[1] ?? '';

  if (GMAIL_DOMAINS.includes(domain)) {
    return 'gmail';
  }

  return OUTLOOK_DOMAIN.test(domain) ? 'outlook' : 'other';
}

/**
 * What to type into the mailbox search. Gmail leaves Spam and Trash out of a
 * search unless it is told otherwise, and the email we look for is most likely
 * in Spam.
 */
export function mailboxSearchQuery(provider: MailProvider): string {
  return provider === 'gmail' ? `in:anywhere ${CODE_EMAIL_SEARCH_KEYWORD}` : CODE_EMAIL_SEARCH_KEYWORD;
}
